import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ErrorDialogComponent } from '../dialogs/error-dialog/error-dialog.component';
import { LoadingDialogService } from '../dialogs/loading-dialog/loading-dialog.service';
import { ErrorDetails } from '../exception/error-details';

@Injectable({ providedIn: 'root' })
export class LoadingDialogInterceptor implements HttpInterceptor {
  constructor(
    public loadingService: LoadingDialogService,
    private dialog: MatDialog
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let currentLoad = this.loadingService.start();

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let parsedError: any;

        if (error && error.error) {
          if (typeof error.error == 'string') {
            parsedError = Object.assign({}, error, {
              error: JSON.parse(error.error),
            });

            // console.log(parsedError.error.message);
            // console.log(parsedError.error.message.indexOf('error_usuario_sem_permissao'));
          } else {
            parsedError = error;
          }
        }

        if (
          ![401, 403].includes(error.status) ||
          ([401].includes(error.status) &&
            parsedError &&
            parsedError.error &&
            parsedError.error.message &&
            parsedError.error.message.indexOf('error_usuario_sem_permissao') !=
              -1)
        ) {
          let curentError: string = 'Erro no retorno do servico';

          let errorDetails: ErrorDetails = new ErrorDetails(
            new Date(),
            '',
            '',
            []
          );

          if (error && error.error) {
            if (typeof error.error == 'string') {
              errorDetails = parsedError.error;
            } else {
              errorDetails = error.error;
            }

            if (errorDetails.message != 'INVALID_CREDENTIALS') {
              curentError = curentError + ': ' + errorDetails.message;
            } else {
              curentError = 'Usuário ou senha incorretos!';
            }
          } else if (error && error.message) {
            curentError = curentError + ': ' + error.message;
          }

          this.dialog.open(ErrorDialogComponent, {
            data: {
              title: 'Erro',
              message: curentError,
            },
          });
        }

        return throwError(error);
      }),

      finalize(() => {
        this.loadingService.stop();
      })
    );
  }
}
